<!-- @format -->
<template>
    <div
        class="d-flex flex-column flex-md-row u-width-100 u-height-100"
        :style="{ 'min-height': 0 }">
        <div
            v-if="$vuetify.breakpoint.mdAndUp"
            class="col col-md-8 col-lg-9 d-flex px-0 py-0 u-height-100 u-position-relative justify-center"
            :style="{ position: 'absolute', top: 0 }">
            <HotelDetailsV2
                v-if="highlightedHotelReservation"
                :has-value="!!highlightedHotelReservation || !!selectedHotelReservation"
                :item="
                    !selectedHotelReservation
                        ? highlightedHotelReservation
                        : selectedHotelReservation.item
                "
                :bus-events-parent="busEvent"
                :event="event"
                :bundle-products="bundleProductsOnlyHotels"
                class="flex-grow-1 u-overflow-scroll-y"
                :in-location="currentLocation" />
        </div>
        <div
            class="col col-md-4 col-lg-3 pa-0 ml-auto u-height-100"
            :style="{ position: 'absolute', right: 0 }">
            <EventSidebar
                class="u-position-relative"
                :disabled-button="!canSubmit"
                :display-footer="isFooterDisplayed"
                footer-title="Total"
                :submit-button-placeholder="$t('_components.eventSidebar.buttons.checkout')"
                :bundle-products="bundleProductsOnlyHotels"
                :event="event"
                @submit="onSubmitDo">
                <AddHotelReservation
                    v-if="!bookingLoading && hotel"
                    :value="selectedHotelReservation"
                    :event="event"
                    :bus-events-parent="busEvent"
                    :bundle-products="bundleProductsOnlyHotels"
                    :init-from-query="initFromQuery"
                    :start-date-time="startDateReservation"
                    :end-date-time="endDateReservation"
                    default-view="list"
                    :rooms-count="roomsCount"
                    :quantity="guestsCount"
                    :in-location="currentLocation"
                    :distance-unit-of-measure="distanceUnitOfMeasure"
                    :highlighted-item="highlightedHotelReservation"
                    :limit="hotelsLimit"
                    :range="hotelsRange"
                    :load-only-first-limit="false"
                    suppress-auto-highlight
                    :allow-toggle-view="false"
                    uniform-hotel-card
                    @change-show-filter="$emit('change-show-filter', $event)"
                    @highlight-item="setHighlightedHotelReservation"
                    @input="onInputDo">
                    <template slot="empty-list">
                        <HotelsNoDataReplace />
                    </template>
                    <template slot="list-inner-scroll-header">
                        <HotelsInfoPanelReplace class="mx-2 my-md-3 my-2" />
                    </template>
                </AddHotelReservation>
            </EventSidebar>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapState, mapActions } from 'vuex';
import { getDistanceUnitOfMeasureForCountry } from '@core/utils/measureUtils';
import productsConstants from '@core/utils/constants/products';
import locationsConstants from '@tenant/app/utils/constants/locations';
import AddHotelReservation from '@tenant/app/modules/hotel/features/addHotelReservation/AddHotelReservation.vue';
import HotelDetailsV2 from '@tenant/app/modules/hotel/components/containers/HotelDetailsV2.vue';
import hotelsConstants from '@tenant/app/utils/constants/hotels';
import EventFlowMixin from '@tenant/app/mixins/EventFlowMixin';
import EventSidebar from '@tenant/app/views/eventV2/TheEventPostPurchase/_components/EventSidebar.vue';
import { create as CreateBundleProductsModel } from '@tenant/app/modelsV2/BundleProductsModel';
import { create as CreateBundleProductsHotelReservationModel } from '@tenant/app/modelsV2/BundleProductsHotelReservationModel';
import { create as CreateBundleProductsEventTicketModel } from '@tenant/app/modelsV2/BundleProductsEventTicketModel';
import tmEventConstants from '@tenant/app/utils/constants/event';
import HotelsNoDataReplace from './_components/HotelsNoDataReplace.vue';
import HotelsInfoPanelReplace from './_components/HotelsInfoPanelReplace.vue';

export default {
    name: 'TheManageBookingReplace',
    components: {
        AddHotelReservation,
        EventSidebar,
        HotelDetailsV2,
        HotelsNoDataReplace,
        HotelsInfoPanelReplace,
    },
    mixins: [EventFlowMixin],
    props: {
        isNoEvent: {
            type: Boolean,
            default: true,
        },
        initFromQuery: {
            type: Boolean,
            default: false,
        },
        bundleProducts: {
            type: Object,
            default: () => {},
        },
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking',
    },
    testIdOptions: {
        keyPrefix: 'manageBookingReplace',
    },
    data() {
        return {
            busEvent: new Vue(),
            selectedHotelReservation: null,
            highlightedHotelReservation: null,
            event: new Object(),
        };
    },
    computed: {
        ...mapState({
            list: (state) => state.addHotelReservationState.hotels.list,
            loading: (state) => state.addHotelReservationState.hotels.loading,
            listFilters: (state) => state.addHotelReservationState.hotels.filters,
        }),
        ...mapGetters({
            cartId: 'booking/getCartId',
            billingDetails: 'booking/getBillingDetails',
            room: 'booking/getRoom',
            hotel: 'booking/getHotel',
            bookingLoading: 'booking/loading',
        }),
        computedCartId() {
            return this.cartId || this.$route.params.id;
        },
        hotelsLimit() {
            return hotelsConstants.HOTEL_ONLY.limit;
        },
        hotelsRange() {
            return hotelsConstants.HOTEL_ONLY.range;
        },
        endDateReservation() {
            return new Date(this.hotel.accommodation.endDateTime);
        },
        startDateReservation() {
            return new Date(this.hotel.accommodation.startDateTime);
        },
        currentLocation() {
            return {
                city: this.room.address.cityName,
                countryCode: this.room.address.countryCode,
                latitude: this.room.latitude,
                longitude: this.room.longitude,
                name: this.room.address.cityName,
                type: locationsConstants.TYPES.HOTEL,
            };
        },
        guestsCount() {
            return (
                this.hotel.accommodation.guests.adultsCount +
                this.hotel.accommodation.guests.childrenCount
            );
        },
        roomsCount() {
            return this.hotel.accommodation.roomsCount;
        },
        distanceUnitOfMeasure() {
            return getDistanceUnitOfMeasureForCountry(this.currentLocation.countryCode);
        },
        canSubmit() {
            return !!this.selectedHotelReservation;
        },
        isFooterDisplayed() {
            return !!this.selectedHotelReservation;
        },
        bundleProductsOnlyHotels() {
            return CreateBundleProductsModel(
                CreateBundleProductsEventTicketModel({ ...this.event }, null, null, null, 0, 0),
                this.selectedHotelReservation
                    ? CreateBundleProductsHotelReservationModel(this.selectedHotelReservation.item)
                    : null
            );
        },
    },
    watch: {
        loading: function (newValue, oldValue) {
            if (newValue !== oldValue && this.list.length)
                this.highlightedHotelReservation = this.list[0];
        },
    },
    methods: {
        ...mapActions({
            setEventFlow: 'events/setEventFlow',
            cartReplaceHotel: 'cart/replaceHotel',
            setBookingNeedsUpdate: 'booking/setNeedsUpdate',
            addSelection: 'orderSelection/add',
            clear: 'orderSelection/clear',
        }),
        onInputDo(item) {
            if (item) {
                this.selectedHotelReservation = {
                    ...item,
                };
                this.addSelection({
                    type: productsConstants.TYPES.HOTEL_RESERVATION,
                    item: this.selectedHotelReservation,
                });
            } else {
                this.selectedHotelReservation = null;
                this.clear({ type: productsConstants.TYPES.HOTEL_RESERVATION });
            }
        },
        async onSubmitDo() {
            const contactPerson = {
                firstName: this.billingDetails.firstName,
                lastName: this.billingDetails.lastName,
                email: this.billingDetails.emailAddress,
            };
            const hotelReservation = {
                hotel: this.selectedHotelReservation.item,
                room: this.selectedHotelReservation.item.selectedRoom,
                accommodation: {
                    startDateTime: this.selectedHotelReservation.startDateTime,
                    endDateTime: this.selectedHotelReservation.endDateTime,
                    roomsCount: this.selectedHotelReservation.roomsCount,
                    guests: this.selectedHotelReservation.guests,
                },
                contactPerson: contactPerson,
                guests: [contactPerson],
            };
            this.$router.push({
                name: 'booking.replace.checkout',
                params: { id: this.computedCartId, hotelReservation: hotelReservation },
            });
        },
        setHighlightedHotelReservation(hotelReservation) {
            this.highlightedHotelReservation = hotelReservation;
        },
    },
    created() {
        this.setEventFlow({ flow: tmEventConstants.FLOWS.MANAGE_BOOKING });
    },
    mounted() {
        this.highlightedHotelReservation = this.list?.[0];
    },
};
</script>
